import contentControls from "./contentControlsService";
import { REPEATING_TABLE_BLOCK } from "@/constants/contentControlTypes";
import { REPEATING_TABLE_BLOCK as BLOCK_COLOR } from "@/constants/contentControlColors";
import { tryLoadProperties } from "@/util/wordUtil";

const add = (name, hideBoundingBox = false) => new Promise(resolve => {
    const title = `Sharedo ${REPEATING_TABLE_BLOCK}: ${name}`;
    const options = {
        color: BLOCK_COLOR,
        tag: name,
        hideBoundingBox
    };

    contentControls.insert(title, options, async ({ contentControl, parentContentControl, context }) => {
        const table = contentControl.insertTable(1, 3, "Start");
        const tableRange = table.getRange("Start");
        const controlStart = contentControl.getRange("Start");
        const toDelete = controlStart.expandTo(tableRange);
        toDelete.delete();

        await context.sync();

        tryLoadProperties(context, contentControl, "id").then(() => {
            const retVal = { id: contentControl.id };

            if (parentContentControl) {
                retVal.parentId = parentContentControl.id;
            }

            resolve(retVal);
        });
    });
});

export default {
    add,
}